/**
 * PostHog roda sem scripts externos: a CSP mantém `script-src 'self'` (SYNAP-DOC-2W/2X/2Y).
 * `disable_external_dependency_loading` é o portão único de `loadScript` no posthog-js
 * (remote-config `config.js`, recorder, surveys, toolbar, product tours, conversations,
 * logs, web vitals, exception/dead-clicks autocapture, tracing headers, integrações, site apps);
 * as flags abaixo desligam explicitamente os recursos que dependeriam desses scripts,
 * para que flags remotas do projeto não tentem reativá-los.
 */
export const POSTHOG_NO_EXTERNAL_SCRIPTS_OPTIONS = {
  disable_external_dependency_loading: true,
  disable_session_recording: true,
  disable_surveys: true,
  disable_product_tours: true,
  disable_conversations: true,
  opt_in_site_apps: false,
  capture_exceptions: false,
  capture_dead_clicks: false,
  capture_performance: false,
} as const
